import React from 'react'

import useSettingsState from '@/hooks/useSettingsState'
import { THEME } from '@/lib/constants'

const initialState = {
  theme: THEME.LIGHT,
}

const ThemeContext = React.createContext(initialState)

const ThemeProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [theme] = useSettingsState('theme', THEME.LIGHT)

  return (
    <ThemeContext.Provider value={{ theme }}>{children}</ThemeContext.Provider>
  )
}

export { ThemeProvider }
